import { useMemo } from 'react';

import { useOrderData } from './useOrderData';

export const useOrderedProducts = (supplierSlug: string) => {
  const [orderData] = useOrderData(supplierSlug);
  const orderedProducts = useMemo(() => {
    return Object.fromEntries(Object.entries(orderData.products).filter(([_, ordered]) => ordered.quantity > 0));
  }, [orderData.products]);

  return orderedProducts;
};
